module.exports = __webpack_public_path__ + "static/media/send-mail.f2803b87.svg";